import { render, staticRenderFns } from "./email-modal.vue?vue&type=template&id=359bc294&scoped=true&"
import script from "./email-modal.vue?vue&type=script&lang=js&"
export * from "./email-modal.vue?vue&type=script&lang=js&"
import style0 from "./email-modal.vue?vue&type=style&index=0&id=359bc294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359bc294",
  null
  
)

component.options.__file = "email-modal.vue"
export default component.exports